import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	Button,
	TextField,
} from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import {
	useAddActorMutation,
	useAddAuthorMutation,
	useDeleteAuthorMutation,
	useUpdateAuthorMutation,
} from '../../../store/apiSlice';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function ActorCreate(props) {
	const classes = useStyles();
	const navigate = useNavigate();

	const [newActorName, setNewAuthorName] = useState('');
	const [addActor] = useAddActorMutation();
	const handleAdd = (e) => {
		addActor({ name: newActorName });
		navigate('/admin/actors');
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Нов актьор</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Нов актьор
					</Typography>

					<TextField
						value={newActorName}
						onChange={(e) => setNewAuthorName(e.target.value)}
						placeholder="Име на актьорa"
					></TextField>
					<Button startIcon={<EditIcon />} onClick={handleAdd}>
						Запис
					</Button>
				</Paper>
			</Container>
		</div>
	);
}
